export default "__VITE_ASSET__BbdOKQa1__"